import { getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import TextDropdown from 'src/components/TextDropdown/TextDropdown'
import { useExtendLocation } from 'src/hooks/locationHooks'
import Trns, { translateSingleString } from 'src/localization/Trns'
import { useQueryMccGroups } from 'src/queries/mccGroups.queries'
import { defaultQueryCacheOptions } from 'src/queries/queries.constants'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

interface TransactionMerchantCategoryFilterProps {
  mccGroupSet: Set<string>
  handleMccGroupSelection: (groupId: string) => Set<string>
  setMccGroupSet: (groups: Set<string>) => void
  defaultFilters: {
    mccGroup?: Set<string>
  }
}

const TransactionMerchantCategoryFilter: React.FC<TransactionMerchantCategoryFilterProps> = ({
  mccGroupSet,
  handleMccGroupSelection,
  setMccGroupSet,
  defaultFilters,
}) => {
  const extendLocation = useExtendLocation()

  const locale = useSelector(selectNullSafeLocaleFromState)

  const { data: mccData } = useQueryMccGroups(
    {
      additionalKey: extendLocation.matchedPath,
      queryCacheOptions: defaultQueryCacheOptions,
    }
  )

  const mccOptions = useMemo(
    () =>
      mccData?.map((mcc) => ({
        value: mcc.id,
        details: {
          text: mcc.group,
        },
      })) ?? [],
    [mccData],
  )

  return (
    <>
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Merchant Category'} />
      </div>
      <TextDropdown
        css={css`
          margin-top: 8px;
        `}
        placeholder={translateSingleString(locale, 'All categories')}
        chooseOption={(val: string): void => {
          handleMccGroupSelection(val)
        }}
        isMulti={true}
        selectedValues={mccGroupSet}
        optionGroups={[
          {
            options: mccOptions,
          },
        ]}
        onResetClick={(): void => {
          setMccGroupSet(defaultFilters.mccGroup || new Set<string>())
        }}
      />
    </>
  )
}

export default TransactionMerchantCategoryFilter
